import basicCustomInsightConsts from 'actions/modules/insight/custom/basicConsts'

export default (() => {
  const { BASIC_CHART_TYPES, BASIC_INPUT_PARAM_TYPES, CHART_SOURCES } = basicCustomInsightConsts

  const isFileLikeSource = ({ sourceType, inputParamsType }) =>
    sourceType === CHART_SOURCES.FILE.value
    || sourceType === CHART_SOURCES.SQL_CREATOR.value
    || (sourceType === CHART_SOURCES.SOURCE_TILE.value && [
      BASIC_INPUT_PARAM_TYPES.FILE.value,
      BASIC_INPUT_PARAM_TYPES.SQL.value
    ].includes(inputParamsType))

  const isFileLikeChartSource = ({ sourceType, inputParamsType, basicChartType }) =>
    isFileLikeSource({ sourceType, inputParamsType })
    && !(sourceType === CHART_SOURCES.SOURCE_TILE.value
      && inputParamsType === BASIC_INPUT_PARAM_TYPES.SQL.value
      && basicChartType === BASIC_CHART_TYPES.COMPOSED.value)

  const isInputParamsSourceSelectable = ({ basicChartType, inputParamsType }) => {
    if(basicChartType === BASIC_CHART_TYPES.FORWARD_CURVE.value) {
      return inputParamsType === BASIC_INPUT_PARAM_TYPES.CURVE.value
    }
    return inputParamsType !== BASIC_INPUT_PARAM_TYPES.CURVE.value
      && !(basicChartType === BASIC_CHART_TYPES.COMPOSED.value
        && inputParamsType === BASIC_INPUT_PARAM_TYPES.SQL.value)
  }

  return { isFileLikeChartSource, isFileLikeSource, isInputParamsSourceSelectable }
})()
